<template>
  <div>
    <NuxtImg
      loading="lazy"
      :src="avatarSrc"
      alt=""
      class="h-full w-full rounded-full overflow-hidden shadow"
      width="175"
      height="175"
    />
  </div>
</template>

<script setup>
const DEFAULT_AVATAR = "https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_3_7.png";

const props = defineProps({
  img: {
    type: String,
    default: DEFAULT_AVATAR,
  },
});

const avatarSrc = computed(() => props.img || DEFAULT_AVATAR);
</script>
